import React from 'react';

export type PromotionSectionState = 'complete' | 'problem' | 'incomplete';

interface PromotionEditorSectionProps {
  number: number;
  title: string;
  summary: string;
  state: PromotionSectionState;
  open: boolean;
  onToggle: () => void;
  onContinue: () => void;
  help?: React.ReactNode;
  children: React.ReactNode;
}

const PromotionEditorSection: React.FC<PromotionEditorSectionProps> = ({
  number,
  title,
  summary,
  state,
  open,
  onToggle,
  onContinue,
  help,
  children,
}) => {
  const contentId = `promotion-section-${number}-content`;
  return (
    <section
      className={`promotion-editor-section promotion-editor-section--${state}${open ? ' is-open' : ''}`}
      aria-labelledby={`promotion-section-${number}-heading`}
    >
      <button
        id={`promotion-section-${number}-heading`}
        type='button'
        className='promotion-editor-section__toggle'
        aria-expanded={open}
        aria-controls={contentId}
        onClick={onToggle}
      >
        <span className='promotion-editor-section__number'>{number}</span>
        <span className='promotion-editor-section__heading'>
          <strong>{title}</strong>
          {!open && <span>{summary}</span>}
        </span>
        <span
          className='promotion-editor-section__state'
          aria-label={
            state === 'complete'
              ? 'Complete'
              : state === 'problem'
                ? 'Needs attention'
                : 'Not complete'
          }
        >
          {state === 'complete' ? '✓' : state === 'problem' ? '●' : ''}
        </span>
      </button>
      {open && (
        <div id={contentId} className='promotion-editor-section__content'>
          {help}
          {children}
          <div className='promotion-editor-section__footer'>
            <button
              type='button'
              className='launch-btn launch-btn--quiet'
              onClick={onContinue}
            >
              Continue
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default PromotionEditorSection;
